import { STATUS } from "@/constants/statuses";
import { Observable, catchError, from, tap } from "rxjs";
import { singleton } from "tsyringe";

import { LoggerInterface } from "@interfaces/LoggerInterface";

import ShopifyDiscountStore from "../store/ShopifyDiscountStore";
import { DiscountServiceStrategyInterface } from "./DiscountServiceStrategyInterface";

@singleton()
export class DiscountService {
    constructor(
        private shopifyDiscountStore: ShopifyDiscountStore,
        private strategy: DiscountServiceStrategyInterface,
        private readonly logger: LoggerInterface
    ) {}

    public setStrategy(strategy: DiscountServiceStrategyInterface): void {
        this.strategy = strategy;
    }

    public applyDiscount(
        discountCode: string,
        itemId: number | string
    ): Observable<unknown> {
        this.logger.debug("DiscountService.applyDiscount is started");

        this.shopifyDiscountStore.setDiscountStatus(STATUS.LOADING, itemId);

        return from(this.strategy.applyDiscount({ discountCode })).pipe(
            catchError((error: unknown) => {
                this.logger.debug(
                    "DiscountService.applyDiscount is errored",
                    error
                );

                this.shopifyDiscountStore.setDiscountStatus(
                    STATUS.ERROR,
                    itemId
                );
                throw error;
            }),
            tap(() => {
                this.logger.debug("DiscountService.applyDiscount is ready");

                this.shopifyDiscountStore.setDiscountStatus(
                    STATUS.READY,
                    itemId
                );
            })
        );
    }
}
